import React, { useContext } from "react";

import { DataContext } from "../../../../../../providers/PelletsCheckoutDataProvider";
import StorageHandler from "../../../../../../utils/StorageHandler";
import Headline from "../../../../../shared/NewHeadline";
import { AmountInput } from "../../../CalculatorPage/Calculator";

const Amount = () => {
    const storage = new StorageHandler();
    const dataContext = useContext(DataContext);
    const { amount } = dataContext.data;
    const { setAmount, addFormError, clearFormError, hasFormErrorAt } =
        dataContext.actions;

    const productType = storage.get("pel:order-product-type");

    /**
     * When the amount changes.
     *
     * @param {*} event
     */
    const onChangeAmount = (event) => {
        setAmount(event.target.value);
    };

    return (
        <React.Fragment>
            <Headline>Menge</Headline>
            <AmountInput
                inputOnly
                product={productType}
                amount={amount}
                onChange={onChangeAmount}
                onError={() => addFormError("pelLooseAmount")}
                onErrorSolved={() => clearFormError("pelLooseAmount")}
                error={hasFormErrorAt("pelLooseAmount")}
            />
        </React.Fragment>
    );
};

export default Amount;
